import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxChartsModule } from '@stoick/ngx-15-charts';
import { MaterialModule } from '../common-modules/material.module';
import { SharedModule } from '../shared/shared.module';
import { PrintPageComponent } from './print-page.component';
import { PrintExtraIndicatorComponent } from './print-extra-indicator/print-extra-indicator.component';
import { PrintMpgComponent } from './print-mpg/print-mpg.component';
import { PrintMpgElementsComponent } from './print-mpg-elements/print-mpg-elements.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { TooltipComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, SankeyChart } from "echarts/charts";
import * as echarts from 'echarts/core';
import { PrintPageLandscapeComponent } from './print-page-landscape/print-page-landscape.component';
import { TranslateModule } from '@ngx-translate/core';
import { PrintMpgElementsLandscapeComponent } from './print-page-landscape/print-mpg-elements-landscape/print-mpg-elements-landscape.component';
import { PrintMpgLandscapeComponent } from './print-page-landscape/print-mpg-landscape/print-mpg-landscape.component';
import { PrintExtraIndicatorLandscapeComponent } from './print-page-landscape/print-extra-indicator-landscape/print-extra-indicator-landscape.component';
import { PrintCombinationBuildingDetailsComponent } from './print-page-landscape/print-combination-building-details/print-combination-building-details.component';


echarts.use([BarChart, SankeyChart, CanvasRenderer, TooltipComponent]);


@NgModule({
    declarations: [PrintPageComponent, PrintExtraIndicatorComponent, PrintMpgComponent, PrintMpgElementsComponent, PrintPageLandscapeComponent, PrintMpgElementsLandscapeComponent, PrintMpgLandscapeComponent, PrintExtraIndicatorLandscapeComponent, PrintCombinationBuildingDetailsComponent],
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule,
        MaterialModule,
        NgxChartsModule,
        NgxEchartsModule.forRoot({ echarts })
    ]
})
export class PrintPageModule { }
